import { constants } from "./constants";

// Carica lo stato iniziale dal localStorage (se esiste)
const savedReduxObject = localStorage.getItem("redux_object");

const initialState = {
  isAuthenticated: !!savedReduxObject,
  redux_object: savedReduxObject ? JSON.parse(savedReduxObject) : null,
  error: null,
};

const cleanInitialState = {
  isAuthenticated: false,
  redux_object: null,
  error: null,
};

// aggiorna il localStorage  user - token
const updateLocalStorage = (reduxObject) => {
  const storageObject = {
    user: reduxObject.user,
    accessToken: reduxObject.accessToken,
  };
  localStorage.setItem("redux_object", JSON.stringify(storageObject));
};

const userReducer = (state = initialState, action) => {
  let updatedReduxObject;

  switch (action.type) {
    // login
    case constants.LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        error: null,
      };

    case constants.LOGIN_SUCCESS: {
      const reduxObject = {
        user: action.payload.user,
        accessToken: action.payload.access_token,
      };
      // salva  user - token
      updateLocalStorage(reduxObject);

      return {
        ...state,
        isAuthenticated: true,
        redux_object: reduxObject,
        error: null,
      };
    }
    // logout
    case constants.LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: JSON.parse(action.payload.error),
      };

    case constants.LOGOUT_SUCCESS:
      localStorage.removeItem("redux_object");
      return cleanInitialState;

    case constants.LOGOUT_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: action.payload.error,
      };
    // user
    case constants.GET_USER_REQUEST:
      return {
        ...state,
        error: null,
      };

    case constants.GET_USER_SUCCESS: {
      const token = state.redux_object?.accessToken;

      const reduxObject = {
        user: action.payload,
        accessToken: token,
      };

      updateLocalStorage(reduxObject);

      return {
        ...state,
        isAuthenticated: true,
        redux_object: reduxObject,
        error: null,
      };
    }
    case constants.GET_USER_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
